import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import AddForm from './Methods/Manual'
import ImportFile from './Methods/Import'
import { ADD_PROMPT, useAddToListStore } from 'src/store/lists/AddToListStore'

const Prompt = observer((): ReactElement => {
  const addToListStore = useAddToListStore()
  const method = addToListStore.getSelectedPrompt()
  return (
    <>
      {method == ADD_PROMPT.MANUAL && <AddForm />}
      {method == ADD_PROMPT.IMPORT_FILE && <ImportFile />}
    </>
  )
})

export default Prompt
